import { render, staticRenderFns } from "./eventType.vue?vue&type=template&id=65da04ec&scoped=true&"
import script from "./eventType.vue?vue&type=script&lang=js&"
export * from "./eventType.vue?vue&type=script&lang=js&"
import style0 from "./eventType.vue?vue&type=style&index=0&id=65da04ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65da04ec",
  null
  
)

export default component.exports